import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadQidModelById,
    setQidModelEditModel,
    setQidModelReloadEditModel,
    initQidModel,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface QidModelEditProps {
    modelId: number
}

const Edit = ({
    modelId = null,
}: QidModelEditProps) => {
    const product = useSelector((state: StoreType) => state.qidProduct.productView)
    const model = useSelector((state: StoreType) => state.qidModel.editModel)
    const reloadEdit = useSelector((state: StoreType) => state.qidModel.reloadEditModel)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setQidModelReloadEditModel(false))
        setTimeout(() => {
            dispatch(setQidModelReloadEditModel(true))
        }, 0)
    }

    useEffect(() => {
        if (modelId === 0) {
            dispatch(setQidModelEditModel({
                ...initQidModel,
                productId: product.id,
                type: product.type,
                lowDemandMode: product.lowDemandMode,
                highDemandMode: product.highDemandMode,
                continuousMode: product.continuousMode,
                logicSolver: product.logicSolver,
                provenInUse: product.provenInUse,
            }))

            reload()
        } else {
            setLoadState(PENDING)
            LoadQidModelById(modelId).then((res) => {
                dispatch(setQidModelEditModel(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!model) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {model.id ? `${lang.editModel} # ${model.id}` : lang.addModel}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form model={model} />
                }
                {
                    reloadEdit
                    && <Form model={model} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
